import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataTablesResponse} from '../models/dataTables-response';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MerchantService {

    constructor(private http: HttpClient) {
    }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}merchants/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(status: any = ''): Observable<any> {
        if (status) {
            status = `?status=${status}`;
        }
        return this.http.get(`${webServiceConfig.webServiceUrl}merchants${status}`).pipe(map(response => {
            return response;
        }));
    }

    getById(merchantId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}merchants/${merchantId}`).pipe(map(response => {
            return response;
        }));
    }

    store(merchant: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}merchants`, merchant)
            .pipe(map(response => {
                return response;
            }));
    }

    update(merchant: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}merchants/${merchant.id}`, merchant)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}merchants/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
